import { StringMap } from '@angular/compiler/src/compiler_facade_interface';

export class PaymentEmail{
    public orderId : string;
    public transactionId : string;
    public Email : string;
}